import { createApp } from 'vue';
import plugin from '../../plugins';
import com from './com.vue';

export default function initCopyRight(globalData = {}) {
    if (globalData.hasGotoTop) {
        var app = createApp(com, {});
        plugin.baseInstall(app, true).mountSelf();
    }
}